import React, { useEffect } from 'react';
import { AgreementsList } from './components/table/AgreementsList';
import { Agreements } from '../../types/Agreements.types';
import { useAgreements } from '../../hooks/api/useAgreements';
import { useAuthContext } from '../../contexts/AuthContext';
import Loader from '../../components/Loader';

function AgreementsListContainer() {
  const { fetchAgreements } = useAgreements();
  const { account } = useAuthContext();
  const [agreements, setAgreements] = React.useState<Agreements[]>();
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    const getAgreements = async () => {
      try {
        setIsLoading(true);
        const res: Agreements[] = await fetchAgreements();
        setAgreements(res);
      } catch (error) {
        console.error('Failed to fetch agreements:', error);
        setAgreements([]);
      } finally {
        setIsLoading(false);
      }
    };
    getAgreements();
  }, [fetchAgreements, account]);

  if (isLoading || !agreements) {
    return <Loader />;
  }

  return <AgreementsList agreements={agreements} journals={[]} />;
}

export default AgreementsListContainer;
